export const platMap = [
    {
        id:'1',
        name:'oppo',
        displayName:'OPPO'
    },
    {
        id:'2',
        name:'gionee',
        displayName:'金立'
    },
    {
        id:'3',
        name:'vivo',
        displayName:'vivo'
    },
    {
        id:'4',
        name:'huawei',
        displayName:'华为'
    },
    {
        id:'10',
        name:'huaweiads',
        displayName:'华为Ads'
    },
    {
        id:'11',
        name:'honor',
        displayName:'荣耀'
    },
    {
        id:'5',
        name:'meizu',
        displayName:'魅族'
    },
    {
        id:'6',
        name:'toutiao',
        displayName:'今日头条'
    },
    {
        id:'7',
        name:'mi',
        displayName:'小米'
    },
    {
        id:'8',
        name:'iqiyi',
        displayName:'爱奇艺'
    },
    {
        id:'9',
        name:'apple',
        displayName:'Apple'
    },
];


export const colorList = [
    {
        name:'light-1',
        bgColor:'#ffffff',
    },
    {
        name:'light-2',
        bgColor:'#ffeae4',      // 背景色
        fontColor:'rgba(0, 0, 0, 0.9)',     // 正常文字颜色
        hoverBgColor:'rgba(255, 31, 0, 0.2)',
        hoverFontColor:'rgb(181, 71, 57)',
        activeBgColor:'rgba(255, 31, 0, 0.2)',
        activeFontColor:'rgb(181, 71, 57)',
    },
    {
        name:'light-3',
        bgColor:'#fff9e6',
        fontColor:'rgba(0, 0, 0, 0.9)',
        hoverBgColor:'rgba(255, 168, 0, 0.2)',
        hoverFontColor:'rgb(182, 130, 25)',
        activeBgColor:'rgba(255, 168, 0, 0.2)',
        activeFontColor:'rgb(182, 130, 25)',
    },
    {
        name:'light-4',
        bgColor:'#dcfdf0',
        fontColor:'rgba(0, 0, 0, 0.9)',
        hoverBgColor:'rgb(188, 231, 216)',
        hoverFontColor:'rgb(45, 135, 110)',
        activeBgColor:'rgb(188, 231, 216)',
        activeFontColor:'rgb(45, 135, 110)',
    },
    {
        name:'light-5',
        bgColor:'#dffdff',
        fontColor:'rgba(0, 0, 0, 0.9)',
        hoverBgColor:'rgb(191, 231, 228)',
        hoverFontColor:'rgb(45, 135, 110)',
        activeBgColor:'rgb(191, 231, 228)',
        activeFontColor:'rgb(45, 135, 110)',
    },
    {
        name:'light-6',
        bgColor:'#dbebff',
        fontColor:'rgba(0, 0, 0, 0.9)',
        hoverBgColor:'rgb(180, 207, 245)',
        hoverFontColor:'rgb(0, 82, 204)',
        activeBgColor:'rgb(180, 207, 245)',
        activeFontColor:'rgb(0, 82, 204)',
    },
    {
        name:'light-7',
        bgColor:'#eae7ff',
        fontColor:'rgba(0, 0, 0, 0.9)',
        hoverBgColor:'rgb(203, 199, 233)',
        hoverFontColor:'rgb(63, 59, 140)',
        activeBgColor:'rgb(203, 199, 233)',
        activeFontColor:'rgb(63, 59, 140)',
    },
    {
        name:'dark-1',
        bgColor:'#0b2c4c',
        fontColor:'rgb(194, 225, 255)',
        hoverBgColor:'rgb(1, 66, 131)',
        hoverFontColor:'#ffffff',
        activeBgColor:'rgb(1, 66, 131)',
        activeFontColor:'#ffffff',
    },
    {
        name:'dark-2',
        bgColor:'#c73e2e',
        fontColor:'rgb(255, 228, 228)',
        hoverBgColor:'rgb(149, 15, 0)',
        hoverFontColor:'#ffffff',
        activeBgColor:'rgb(149, 15, 0)',
        activeFontColor:'#ffffff',
    },
    {
        name:'dark-3',
        bgColor:'#c2800e',
        fontColor:'rgb(255, 240, 190)',
        hoverBgColor:'rgb(134, 85, 0)',
        hoverFontColor:'#ffffff',
        activeBgColor:'rgb(134, 85, 0)',
        activeFontColor:'#ffffff',
    },
    {
        name:'dark-4',
        bgColor:'#008971',
        fontColor:'rgb(184, 255, 255)',
        hoverBgColor:'rgb(0, 64, 52)',
        hoverFontColor:'#ffffff',
        activeBgColor:'rgb(0, 64, 52)',
        activeFontColor:'#ffffff',
    },
    {
        name:'dark-5',
        bgColor:'#00708b',
        fontColor:'rgb(184, 241, 255)',
        hoverBgColor:'rgb(0, 75, 94)',
        hoverFontColor:'#ffffff',
        activeBgColor:'rgb(0, 75, 94)',
        activeFontColor:'#ffffff',
    },
    {
        name:'dark-6',
        bgColor:'#0054cb',
        fontColor:'rgb(184, 212, 255)',
        hoverBgColor:'rgb(1, 62, 146)',
        hoverFontColor:'#ffffff',
        activeBgColor:'rgb(1, 62, 146)',
        activeFontColor:'#ffffff',
    },
    {
        name:'dark-7',
        bgColor:'#3e3b8b',
        fontColor:'rgb(184, 220, 255)',
        hoverBgColor:'rgb(45, 42, 150)',
        hoverFontColor:'#ffffff',
        activeBgColor:'rgb(45, 42, 150)',
        activeFontColor:'#ffffff',
    },
];

